import React, { useState } from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { Image } from '../models/models';
import { Spinner } from 'react-bootstrap';

interface PhotoGalleryProps {
  images: Image[];
}

const PhotoGallery: React.FC<PhotoGalleryProps> = ({ images }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const galleryItems = images.map(image => ({
    original: image.original as string,
    thumbnail: image.thumbnail as string,
    description: image.description,
  }));

  const handleFirstImageLoad = () => {
    setIsLoaded(true);
  };

  return (
    <>
      {!isLoaded && <div className='d-flex justify-content-center my-5'><Spinner animation="border" role="status" variant="primary">
        <span className="visually-hidden">Loading...</span>
      </Spinner></div>}
      {images.length > 0 && (
        <img
          src={images[0].original}
          alt={images[0].description || 'First image'}
          style={{ display: 'none' }}
          onLoad={handleFirstImageLoad}
        />
      )}
      {isLoaded && (
        <ImageGallery
          items={galleryItems}
          showFullscreenButton={true}
          showPlayButton={false}
          lazyLoad={true}
          showIndex={true}
        />
      )}
    </>
  );
};

export default PhotoGallery;
